import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: "",
}

export const settingsTagsFilterSlice = createSlice({
    name: 'settingsTagsFilter',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = settingsTagsFilterSlice.actions

export default settingsTagsFilterSlice.reducer